import React, { useContext, useEffect, useState } from 'react'
import { AppContext } from '../../context/app'
import { useTranslation } from 'react-i18next'
import { withTheme } from 'theming'
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  // PinterestShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from 'react-share'
import facebookLogo from '../../assets/social/share-fb-icon.png'
import TwitterLogo from '../../assets/social/share-x-icon.png'
import EmailLogo from '../../assets/social/share-email-icon.png'
import WhatsappLogo from '../../assets/social/share-whatsapp-icon.png'
import LinkedinLogo from '../../assets/social/share-linkedin-icon.png'
// import PrintrestLogo from '../../assets/social/share-printrest-icon.png'
import RednoteLogo from '../../assets/social/rednote-icon.png'
import CopyIcon from '../../assets/copy-icon.svg'
import CheckIcon from '../../assets/check-icon-copy.svg'
import { raiseToast } from '../../utils/helper'
// import PrintrestLogo from '../../assets/social/share-printrest-icon.png'
// import CopyIcon from '../../assets/copy-icon.svg'
// import CheckIcon from '../../assets/check-icon-copy.svg'
// import { getImage, raiseToast } from '../../utils/helper'

const ShareModal = ({ theme, onClose, link, detailObj = {} }) => {
  const { isCustomTemplate, accountObj } = useContext(AppContext)
  const [isCopied, setIsCopied] = useState(false)
  const { t } = useTranslation()

  // Animation state
  const [show, setShow] = useState(false)

  // Show modal with delay on mount
  useEffect(() => {
    setTimeout(() => setShow(true), 10)
  }, [])

  async function copyTextToClipboard(text) {
    if ('clipboard' in navigator) {
      return await navigator.clipboard.writeText(text)
    } else {
      return document.execCommand('copy', true, text)
    }
  }

  useEffect(() => {
    if (isCopied) {
      setTimeout(() => setIsCopied(false), 2000)
    }
  }, [isCopied])

  const handleCopyClick = () => {
    raiseToast('success', 'link copied!')
    copyTextToClipboard(link)
      .then(() => {})
      .catch((err) => {
        console.error(err)
      })
    setIsCopied(true)
  }

  const handleClose = () => {
    setShow(false)
    setTimeout(() => {
      onClose()
    }, 400)
  }

  return (
    <>
      <div
        style={{
          backgroundColor: isCustomTemplate ? `${theme.c1}90` : '#0a0a0a90',
          opacity: show ? 1 : 0,
          transition: 'opacity 0.4s ease',
        }}
        className={`justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none `}
      >
        <div
          style={{
            transform: show ? 'scale(1)' : 'scale(0.9)',
            opacity: show ? 1 : 0,
            transition: 'all 0.4s ease',
          }}
          className={`relative my-6 w-11/12 md:w-9/12 lg:w-1/2 xl:w-2/5  2xl:w-[36%]`}
        >
          <div
            style={{
              background: isCustomTemplate ? theme.c10 : '#1b242f',
              fontFamily: 'Arial',
              opacity: '0.96',
              boxShadow: '0 4px 20px 0 rgba(0, 0, 0, 0.8), 0 6px 20px 0 rgba(0, 0, 0, 0.90)',
              border: '1px solid white',
              borderRadius: '4px',
            }}
            className="shadow-lg relative flex flex-col p-1 md:p-2"
          >
            <div className="relative w-full">
              <button
                className="absolute right-0 p-1 float-right xl:text-3xl leading-none font-semibold"
                onClick={handleClose}
              >
                <span
                  style={{ color: isCustomTemplate ? theme.c4 : '#fff' }}
                  className={` h-6 w-6 text-xl block outline-none focus:outline-none`}
                >
                  ×
                </span>
              </button>
            </div>
            <div className="flex px-2 md:px-10 mt-4">
              <h3 style={{ color: isCustomTemplate ? theme.c4 : '#fff' }} className={``}>
                {t('share')}
              </h3>
            </div>
            <div className="w-full mt-4 md:mt-10 flex justify-center">
              <div className="flex justify-between items-center w-full px-2 md:px-0 md:w-2/3 h-10">
                <FacebookShareButton url={link}>
                  <img
                    src={facebookLogo}
                    alt="facebookLogo"
                    className="h-full w-10 cursor-pointer"
                  />
                </FacebookShareButton>
                <TwitterShareButton url={link}>
                  <img src={TwitterLogo} alt="TwitterLogo" className="h-full w-10 cursor-pointer" />
                </TwitterShareButton>
                <EmailShareButton url={link} body={link} subject={link}>
                  <img src={EmailLogo} alt="EmailLogo" className="h-full w-10  cursor-pointer" />
                </EmailShareButton>
                <WhatsappShareButton url={link}>
                  <img
                    src={WhatsappLogo}
                    alt="WhatsappLogo"
                    className="h-full w-10 bg-white rounded-full cursor-pointer"
                  />
                </WhatsappShareButton>
                <LinkedinShareButton url={link}>
                  <img
                    src={LinkedinLogo}
                    alt="LinkedinLogo"
                    className="h-full w-10 cursor-pointer"
                  />
                </LinkedinShareButton>
                {/* <PinterestShareButton
                  url={link}
                  media={getImage(accountObj?.cf_domain_name, detailObj?.poster)}
                  >
                  <img
                  src={PrintrestLogo}
                  alt="PrintrestLogo"
                  className="h-full w-10 cursor-pointer"
                  />
                  </PinterestShareButton> */}
                <div>
                  <img
                    src={RednoteLogo}
                    alt="RednoteLogo"
                    className="h-full w-10 cursor-pointer"
                    onClick={() => window.open('https://www.rednote.com.my/', '_blank')}
                  />
                </div>
              </div>
            </div>
            <div className="pb-10 relative mt-4 md:mt-4 px-2 md:px-10 flex-auto">
              <h3 style={{ color: isCustomTemplate ? theme.c4 : '#fff' }} className={``}>
                {t('page_link')}
              </h3>
              <div className="relative flex justify-center items-center mt-1">
                <input
                  type="text"
                  value={link}
                  style={{
                    backgroundColor: isCustomTemplate ? theme.c7 : 'white',
                    borderColor: isCustomTemplate ? theme.c5 : '#707070',
                    color: '#1a1a1a',
                  }}
                  readOnly
                  className=" border text-sm rounded block w-full p-2 pl-2 focus:outline-none line-clamp-1"
                />
                <div
                  style={{
                    borderLeft: '2px solid #c0c0c0',
                    height: '90%',
                    background: isCopied ? '#0b8d1d' : 'white',
                  }}
                  className="right-0 absolute flex justify-center items-center"
                >
                  <img
                    className="cursor-pointer mx-3 "
                    alt="CopyIcon"
                    onClick={handleCopyClick}
                    src={isCopied ? CheckIcon : CopyIcon}
                    style={{ width: '23px' }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default withTheme(ShareModal)
